import types from '../actions/types'

export default function (state = null, action) {
  switch (action.type) {
    case types.SHOW_NOTIFICATION:
      return {
        ...state,
        showNotification: true,
        text: action.payload.text,
        autoHideDuration: action.payload.autoHideDuration,
        action: action.payload.action,
        disableClickAway: action.payload.disableClickAway
      }
    case types.HIDE_NOTIFICATION:
      return { ...state, showNotification: false }
    default:
      return state
  }
}
